import { render, staticRenderFns } from "./BloodPressureMonitorsCreateEdit.vue?vue&type=template&id=1435ccad"
import script from "./BloodPressureMonitorsCreateEdit.vue?vue&type=script&lang=js"
export * from "./BloodPressureMonitorsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports